/**
 * Inventory sync message: optional client-side date parsing for richtext that
 * includes raw feed values (e.g. 20260914). Reveals the block only after a successful parse.
 */
function formatLongUsDate(date) {
  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

function validYmd(year, month, day) {
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  if (!y || !m || !d) return null;
  const dt = new Date(y, m - 1, d);
  if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return null;
  return dt;
}

/**
 * @param {string} html
 * @returns {{ html: string, ok: boolean }}
 */
function replaceFirstDateInHtml(html) {
  /** @type {{ regex: RegExp, parse: (m: RegExpMatchArray) => Date | null }[]} */
  const matchers = [
    {
      regex: /(?<![0-9])(20\d{2}|19\d{2})(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])(?![0-9])/,
      parse: (m) => validYmd(m[1], m[2], m[3]),
    },
    {
      regex: /\b(\d{4})-(\d{2})-(\d{2})(?=\b|T|\s|<)/,
      parse: (m) => validYmd(m[1], m[2], m[3]),
    },
    {
      regex: /\b(\d{1,2})\/(\d{1,2})\/(\d{4})\b/,
      parse: (m) => validYmd(m[3], m[1], m[2]),
    },
    {
      regex: /\b(\d{1,2})-(\d{1,2})-(\d{4})\b/,
      parse: (m) => validYmd(m[3], m[1], m[2]),
    },
  ];

  for (const { regex, parse } of matchers) {
    const m = html.match(regex);
    if (! m) continue;
    const dt = parse(m);
    if (! dt) continue;
    return { html: html.replace(regex, formatLongUsDate(dt)), ok: true };
  }

  const loose = html.match(/\b(\d{4})-(\d{2})-(\d{2})[T\s][0-9.:]+/);
  if (loose) {
    const dt = validYmd(loose[1], loose[2], loose[3]);
    if (dt) {
      return { html: html.replace(loose[0], formatLongUsDate(dt)), ok: true };
    }
  }

  const longMonth =
    /\b(January|February|March|April|May|June|July|August|September|October|November|December)\s+(\d{1,2}),\s*(\d{4})\b/i;
  if (longMonth.test(html)) {
    return { html, ok: true };
  }

  return { html, ok: false };
}

function initInventorySyncDateParse(root = document) {
  root.querySelectorAll('[data-inventory-sync-parse-date="true"]').forEach((container) => {
    if (window.Shopify?.designMode) {
      container.hidden = false;
      return;
    }

    const rte = container.querySelector('.level-indicator-message');
    if (! rte) {
      container.hidden = false;
      return;
    }

    const html = rte.innerHTML;
    const { html: next, ok } = replaceFirstDateInHtml(html);

    if (ok) {
      rte.innerHTML = next.replace(/##/g, '');
      container.hidden = false;
    } else {
      container.hidden = true;
    }
  });
}

let inventorySyncVariantListenerBound = false;

function onReady() {
  initInventorySyncDateParse(document);
  if (window.eventBus && !inventorySyncVariantListenerBound) {
    inventorySyncVariantListenerBound = true;
    window.eventBus.on('variant:updated', () => {
      requestAnimationFrame(() => initInventorySyncDateParse(document));
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', onReady);
} else {
  onReady();
}
